export default function Intro() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section
      id="intro"
      className="w-full bg-background-50 py-10 md:py-12 lg:py-14"
    >
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <p className="text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
          Who We Are
        </p>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-snug">
          Building Knowledge. Developing Capability. Creating Connections.
        </h2>
        <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed max-w-3xl mx-auto">
          Amin &amp; Jahan Corporation Ltd. is an integrated research,
          development and promotion service provider. Its activities span
          research, media and publications, professional training, consultancy,
          industry events, global engagement, business promotion and innovation
          development.
        </p>
        <p className="mt-4 text-base md:text-lg text-foreground-700 leading-relaxed max-w-3xl mx-auto">
          Over the years, A&amp;J has developed platforms and initiatives that
          connect industry professionals, businesses, researchers, experts,
          institutions and emerging talent.
        </p>
        <button
          type="button"
          onClick={() => scrollTo("#what-we-do")}
          className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
        >
          Discover A&amp;J
          <i className="ri-arrow-right-line" />
        </button>
      </div>
    </section>
  );
}